import { apiFetch } from './apiClient';



function qs(params = {}) {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const listarTarefas = (params) => apiFetch(`/tarefas${qs(params)}`);
export const criarTarefa = (dados) => apiFetch('/tarefas', { method: 'POST', body: JSON.stringify(dados) });
export const atualizarTarefa = (id, dados) => apiFetch(`/tarefas/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirTarefa = (id) => apiFetch(`/tarefas/${id}`, { method: 'DELETE' });
export const atualizarGrupoTarefa = (grupoId, dados) => apiFetch(`/tarefas/grupo/${grupoId}`, { method: 'PATCH', body: JSON.stringify(dados) });
